var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_2440)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.992 32L32 31.9986V20.2626C32 14.5213 30.764 10.0986 24.052 10.0986C20.8253 10.0986 18.66 11.8693 17.776 13.548H17.6827V10.6346H11.3187V31.9986H17.9453V21.42C17.9453 18.6346 18.4733 15.9413 21.9227 15.9413C25.3213 15.9413 25.372 19.12 25.372 21.5986V32H31.992Z",
    fill: "#A0A3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.528 10.636H7.16267V32H0.528V10.636Z",
    fill: "#A0A3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.84267 0C1.72133 0 0 1.72133 0 3.84267C0 5.964 1.72133 7.72133 3.84267 7.72133C5.964 7.72133 7.68533 5.964 7.68533 3.84267C7.684 1.72133 5.96267 0 3.84267 0Z",
    fill: "#A0A3BD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_2440"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.96a5f803c3e8e05e02bb126ed340bffb.svg";
export { ForwardRef as ReactComponent };